import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';

// i18n real (M7, F8) con "claves naturales": el texto en español ES la clave,
// así que solo existe un diccionario (en.json, español → inglés). Si a una
// clave le falta traducción, se muestra el español (nunca una clave rota).
//
// El idioma se persiste en localStorage y se sincroniza con user.locale del
// perfil (Configuración → Preferencias) a través de syncLocale().

const STORAGE_KEY = 'suscri-locale';

export type AppLocale = 'es' | 'en';

export function getStoredLocale(): AppLocale {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'en' ? 'en' : 'es';
  } catch {
    return 'es';
  }
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: getStoredLocale(),
  fallbackLng: false, // sin traducción -> se muestra la clave (español)
  keySeparator: false, // las claves son frases con puntos y todo
  nsSeparator: false,
  interpolation: { escapeValue: false }, // React ya escapa
  returnEmptyString: false,
});

// Cambia el idioma activo y lo persiste. Llamado desde Configuración y desde
// la sincronización con el perfil al iniciar sesión.
export function setLocale(locale: AppLocale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* localStorage no disponible */
  }
  void i18n.changeLanguage(locale);
}

// Sincroniza con el locale del perfil sin machacar una elección local más
// reciente idéntica (evita renders innecesarios).
export function syncLocale(profileLocale: string | undefined | null): void {
  const target: AppLocale = profileLocale === 'en' ? 'en' : 'es';
  if (i18n.language !== target) setLocale(target);
}

// Locale BCP-47 para formateo de fechas/números coherente con el idioma
export function dateLocale(): string {
  return i18n.language === 'en' ? 'en-GB' : 'es-ES';
}

export default i18n;
